import { render } from "./FormTrainingTestTable.vue?vue&type=template&id=cc3b4ce0&scoped=true&ts=true"
import script from "./FormTrainingTestTable.vue?vue&type=script&lang=ts"
export * from "./FormTrainingTestTable.vue?vue&type=script&lang=ts"

import "./FormTrainingTestTable.vue?vue&type=style&index=0&id=cc3b4ce0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc3b4ce0"]])

export default __exports__